module.exports = __webpack_public_path__ + "static/media/undraw_clean_up_ucm0.ea1d6fd0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_clean_up_ucm0.svg
// module id = 45
// module chunks = 1